<template>
  <div>
    <h3 v-show="this.$route.path === '/personal/myAccount/expenseRecord'">
      消费记录
    </h3>
    <div
      v-show="this.$route.path === '/personal/myAccount/expenseRecord'"
      class="incomebox"
    >
      <div class="choosetime clearfix">
        <p class="fl userinfo">
          账户余额：{{ userInfo.yuanBi }} 源币 l {{ userInfo.coin }} 赠币
        </p>
        <button class="inquirebtn defaultbtn fr" @click="timeBtn">
          查询
        </button>
        <div class="fr">
          <span class="demonstration"> 起止时间：</span>
          <el-date-picker
            v-model="allChoooseTime"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </div>
      </div>
      <el-table :data="tableData" border style="width: 100%" class="table-cell">
        <el-table-column
          prop="consumeType"
          align="center"
          label="交易类型"
          width="180"
        >
        </el-table-column>
        <el-table-column prop="yuanBi" align="center" label="交易金额">
        </el-table-column>
        <el-table-column
          prop="lastCreateTime"
          width="180"
          align="center"
          label="最后一次消费时间"
        >
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="100">
          <template slot-scope="scope">
            <a
              style="color:#48A2DF;fonr-size:14px;display:block;text-align:center"
              @click="handleClick(scope.row)"
              type="text"
              size="small"
              >查看详情</a
            >
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        :hide-on-single-page="true"
        background
        layout="prev, pager, next"
        :total="totalNum"
        :current-page="Current"
        :pager-count="pagecount"
        @current-change="currentChoose"
        class="paginnation-book"
      >
      </el-pagination>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import { getuserInfo } from "@/api/login";
import { groupPay } from "@/api/pay";
export default {
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      allChoooseTime: [],
      tableData: [],
      pagecount: 5,
      userInfo: {},
      totalNum: 0,
      Current: 1
    };
  },
  created() {
    this.$nextTick(() => {
      this.getInfo();
      this.getgroupPay();
    });
  },
  methods: {
    handleClick(row) {
      if (row.consumeTypeValue == 1) {
        this.$router.push({
          path: `/personal/myAccount/rechargeRecord`,
          query: { id: row.consumeTypeValue }
        });
      } else {
        this.$router.push({
          path: `/personal/myAccount/expenseRecord/detail`,
          query: { id: row.consumeTypeValue }
        });
      }
    },
    // 获取用户信息
    async getInfo() {
      let res = await getuserInfo();
      this.userInfo = res.data;
    },
    // 获取交易类型组
    async getgroupPay() {
      let res = await groupPay();
      if (res.success) {
        this.tableData = res.data.items;
        this.tableData.forEach(item => {
          item.yuanBi = `${item.yuanBi}源币`;
        });
        this.totalNum = Number(res.data.totalCount);
        this.Current = Number(res.data.pageNum);
      }
    },
    getTypeList(beginDate, endDate, pageNo, pageSize) {
      groupPay({ beginDate, endDate, pageNo, pageSize })
        .then(res => {
          if (res.success) {
            this.tableData.forEach(item => {
              item.yuanBi = `${item.yuanBi}源币`;
            });
            this.tableData = res.data.items;
            this.Current = Number(res.data.pageNum);
            this.totalNum = Number(res.data.totalCount);
          }
        })
        .catch(() => {});
    },
    timeBtn() {
      if (this.allChoooseTime) {
        this.getTypeList(this.allChoooseTime[0], this.allChoooseTime[1], 1, 10);
      } else {
        this.getTypeList("", "", 1, 10);
      }
    },
    currentChoose(pageNo) {
      if (this.allChoooseTime) {
        this.getTypeList(
          this.allChoooseTime[0],
          this.allChoooseTime[1],
          pageNo,
          10
        );
      } else {
        this.getTypeList("", "", pageNo, 10);
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
.incomebox
    padding 20px 24px
    .lineimgbox
        background rgba(255, 255, 255, 1)
        border-radius 4px
        border 1px solid rgba(211, 211, 211, 1)
        margin-bottom 20px
    .choosetime
        height 54px
        background rgba(255, 255, 255, 1)
        border-radius 4px
        border 1px solid rgba(211, 211, 211, 1)
        line-height 54px
        margin-bottom 20px
        font-size 14px
        font-family PingFangSC-Regular
        font-weight 400
        color rgba(51, 51, 51, 1)
        .inquirebtn
            margin 13px 20px
        .userinfo
            margin-left 28px
            font-weight 600
            color rgba(154, 154, 154, 1)
    .paginnation-book
        position absolute
        bottom 30px
        right 24px
</style>
